import { render, staticRenderFns } from "./ShootingScore.vue?vue&type=template&id=f56b9e0c&scoped=true"
import script from "./ShootingScore.vue?vue&type=script&lang=js"
export * from "./ShootingScore.vue?vue&type=script&lang=js"
import style0 from "./ShootingScore.vue?vue&type=style&index=0&id=f56b9e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56b9e0c",
  null
  
)

export default component.exports